<template>
<section class="margin">
    <div class="flex">
  <h3>Our kid's sessions</h3>
  <h4>Transformative online yoga classes for your kids, no matter how old. <br> Choose the age of your child and enroll them now! While you rest, <br> we'll take care of the rest. </h4>
<div class="buttons">
<button>3-5 years</button>
<button class="button1">5-9 years</button>
<button class="button1">9-12 years</button>
<button class="button1">12-16 years</button>
</div>
</div>
</section>
</template>


<script>
export default {

}
</script>

<style scoped>
.margin{
    margin-top: 125px;
}
.button1{
     color: #FF8100;
  background-color: #FFFFF2;
  border: 2px solid #F1F1DA
}
.flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin: auto;
    text-align: center;
    justify-content: space-around;
    height: 219px;
}
.buttons{
        display: flex;
    justify-content: space-around;
    width: 398px;
    flex-wrap: wrap;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
h3{
    color: #44526B;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 15px;
    border-radius: 50px;
    cursor: pointer;
    transition: 0.3s ease-in;
}

@media (max-width : 1080px){
    .buttons{
max-width: 342px;
margin-top: 17px;
    }
    
}
</style>